import { z } from 'zod';
import { employmentApi } from '../../../api';
import { EMPLOYMENT_EVENT_TYPES } from '../../../../constants/employmentEventTypes';
import { EVENT_ACTOR_TYPES } from '../../../../constants/employmentActorTypes';
import { employmentEpisodeIdSchema } from '../episodeAddress';

/**
 * Validation schema for hire finalization
 */
const finalizeHireSchema = z.object({
  employeeId: z.uuid(),
  employmentEpisodeId: employmentEpisodeIdSchema, // ADR-155 §6
  hireDate: z.iso.date('Hire date must be in ISO format (YYYY-MM-DD)')
});

/**
 * Finalize Hire - Set Employee Start Date
 *
 * @param {Object} payload - Hire finalization data
 * @param {string} payload.employeeId - Required
 * @param {string} payload.hireDate - Required - ISO date format (YYYY-MM-DD)
 * @param {string} [actorType='User'] - Actor type (System, User, Import)
 * @returns {Promise<Object>}
 * @throws {z.ZodError} - If validation fails
 */
export const finalizeHire = async (payload, actorType = EVENT_ACTOR_TYPES.USER) => {
  // Validate payload
  const validatedPayload = finalizeHireSchema.parse(payload);

  return await employmentApi.triggerEmploymentEvents({
    metadata: {
      actorType
    },
    events: [{
      type: EMPLOYMENT_EVENT_TYPES.HIRE_FINALIZED,
      payload: validatedPayload
    }]
  });
};
